export default __webpack_public_path__ + "static/media/shadowedsoul.178e4a94.png";